<template>
  <safe-bank-form
    :init-template="template"
    account-type="safe"
    :submit-action="createSafe"
    :success-msg="t('safeCreated')"
    :enable-clear-form="false"
    :clear-form-on-submit="false"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import SafeBankForm from './SafeBankForm.vue'
import { AccountTemplate } from '@/models/accounting/AccountTemplate'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-safe',

  components: {
    SafeBankForm
  },

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          safeCreated: 'Safe created successfully'
        },
        ar: {
          safeCreated: 'تم إنشاء الخزنة بنجاح'
        }
      }
    })

    return { t }
  },

  data() {
    return {
      template: new AccountTemplate()
    }
  },

  methods: {
    async createSafe(template: AccountTemplate) {
      try {
        await this.$http.post('accounting/accounts/safes', template)
        return null
      } catch (error) {
        return error
      }
    }
  }
})
</script>
